import getters from './getters';
import actions from './actions';
import { defineStore } from "pinia"

function initState() {
    return {
        info: {},
        estPrice: 0, //  Valuation ，0  exhibit ？， No 0 display numbers
        diffPrice: 0 //  difference , rose green ， falling red ，0 do not show
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions
});
